export default __webpack_public_path__ + "media/alexVid.0444ff2d.mp4";